/**
 * Sanitizes chat messages to only allow specific HTML formatting tags and emojis
 * while preventing dangerous HTML injection.
 */
const sanitizeMessage = (html: string): string => {
  // Create a temporary div to parse HTML content
  const div = document.createElement('div');
  div.innerHTML = html;

  // Recursive function to process nodes
  const processNode = (node: Node): Node => {
    // Handle text nodes
    if (node.nodeType === Node.TEXT_NODE) {
      return node;
    }

    // Handle element nodes
    if (node.nodeType === Node.ELEMENT_NODE) {
      const element = node as HTMLElement;
      const tagName = element.tagName.toLowerCase();

      // Only allow specific formatting tags
      if (['b', 'i', 'u'].includes(tagName)) {
        const newElement = document.createElement(tagName);
        Array.from(element.childNodes).forEach(child => {
          newElement.appendChild(processNode(child));
        });
        return newElement;
      }

      // For any other elements, just keep their text content
      const textNode = document.createTextNode(element.textContent || '');
      return textNode;
    }

    // Remove any other type of nodes
    return document.createTextNode('');
  };

  // Process all child nodes
  const cleanNodes = Array.from(div.childNodes).map(node => processNode(node));

  // Create a new div for the sanitized content
  const cleanDiv = document.createElement('div');
  cleanNodes.forEach(node => cleanDiv.appendChild(node.cloneNode(true)));

  return cleanDiv.innerHTML;
};

export { sanitizeMessage };
